import { render, staticRenderFns } from "./union_list.vue?vue&type=template&id=7e2e7035&scoped=true"
import script from "./union_list.vue?vue&type=script&lang=ts"
export * from "./union_list.vue?vue&type=script&lang=ts"
import style0 from "./union_list.vue?vue&type=style&index=0&id=7e2e7035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2e7035",
  null
  
)

export default component.exports